export default {
  leftPanel: {
    title: "Why Join Us?",
    paragraph1: "We are seeking top-tier talents from around the world.",
    paragraph2:
      " At Shanghai Superconductor, we provide a platform where you can turn your dreams into reality. Here, you can fully express your individuality and unleash your passion. ",
    paragraph3: "If you are a high achiever with a relentless pursuit of your dreams, Shanghai Superconductor is where you belong.",
    paragraph4: "Email (Recruitment)：hr{'@'}shsctec.com",
  },

  jobs: {

    salesSpecialist: {
      title: "Domestic Sales",
      details: `Job Responsibilities:
---1.Bidding Work
---Independently complete bid document preparation to ensure a high success rate.
---Collaborate with the team to optimize bid content and enhance competitiveness.
---2.Customer Relationship Management
---Respond promptly to customer needs and handle emergencies.
---Provide comprehensive services to improve customer satisfaction.
---3.Internal Process Optimization
---Participate in the improvement and implementation of company policies, and offer suggestions.
---Assist with document organization, audits, and other tasks to ensure compliance.
---4.Order Execution Management
---Accurately enter order information into the ERP system and track order execution throughout the process. 
---Coordinate with various departments to ensure smooth business operations.
---5.Customer Development
---Actively seek potential customers through market research, industry exhibitions, and online platforms.
---Develop a customer development plan, regularly visit potential customers, understand their needs, and identify cooperation opportunities. Establish good communication with potential customers, introduce the company's product and service advantages, and facilitate cooperation intentions. Track the conversion of potential customers and provide timely feedback on customer development progress to support the company's business expansion.

---Qualifications:
---1.Excellent communication skills and business negotiation abilities.
---2.Ability to independently handle the sales process and solve problems effectively.
---3.Proactive and passionate about sales work.`,
    },
    testEngineer: {
      title: "Test Engineer (R&D Position)",
      details: `Job Responsibilities:
---1.Conduct comprehensive performance testing and analysis of superconducting tapes (wires), coils, and joints.
---2.Perform material performance tests and analyses to ensure they meet industrial application requirements.
---3.Track and research the application of materials in various research institutions and enterprises.
---4.Proficiently operate various testing and characterization equipment.
---5.Responsible for the characterization and optimization of high-temperature superconducting materials' performance.
---Qualifications:
---1.Background in physics, chemistry, materials science, electrical engineering, with preference for electrical engineering.
---2.Strong hands-on skills; experience in superconducting materials is preferred.
---3.Strong observational and analytical skills, familiar with various testing equipment and data processing software.
---4.Responsible, meticulous, with good teamwork and communication skills.`,
    },
    rdEngineer: {
      title: "Research and Development Engineer (R&D Position)",
      details: `Job Responsibilities:
---1.Design and implement specific experimental plans according to the R&D department's schedule.
---2.Analyze and resolve process anomalies in the vacuum coating production line (cleanroom) and implement solutions.
---3.Develop new process technologies and materials to enhance the performance and yield of superconducting tape (wire) products.
---4.Collaborate with colleagues to advance related R&D projects.
---5.Complete other R&D tasks assigned by leadership.
---Qualifications:
---1.Master's degree or above, preferably in materials science, physics, or related fields.
---2. Experience in superconducting materials research, thin-film material preparation, or vacuum coating is preferred.
---3. Long-term commitment, passion for R&D work, and the ability to follow the department's R&D plan.
---4. Strong work ethic, initiative, and excellent professional and dedication spirit.`,
    },
  },
}; 